import { useGetFormDataField } from 'cng-common/features/form'

import { ContactEditorFormKeys } from '../configs'
import { ContactEditorSettingFormFields, ContactFormMenuItems } from '../models'

export const useReadOnlyMenuItem = () => {
  const [isReadOnly] = useGetFormDataField<boolean>(
    ContactEditorFormKeys.settings,
    ContactEditorSettingFormFields.IsReadOnly
  )
  const [editableMenuItem] = useGetFormDataField<ContactFormMenuItems[]>(
    ContactEditorFormKeys.settings,
    ContactEditorSettingFormFields.EditableMenuItems
  )
  const [currentMenuItem] = useGetFormDataField<ContactFormMenuItems>(
    ContactEditorFormKeys.settings,
    ContactEditorSettingFormFields.CurrentMenuItem
  )

  const isCurrentMenuItemReadOnly = isReadOnly || !editableMenuItem.includes(currentMenuItem)

  return { currentMenuItem, isReadOnly, isCurrentMenuItemReadOnly }
}
